<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Contact Info <mat-icon (click)="openEditTitleDialog()" *ngIf="editModeSet" class="edit-icon">edit</mat-icon></h2>
  </div>
  <div class="section__body">
    <div class="section__content event__content">
      <p style="padding-top: 5px">Contact Person: {{ aviationEvent.contactPersonName }}</p>
      <p style="padding-top: 5px" *ngIf="aviationEvent.contactPersonEmail">Contact Email: <a class="overview__website" href="{{ contactEmailAddress }}" target="_blank">{{ aviationEvent.contactPersonEmail }}</a></p>
      <p style="padding-top: 5px" *ngIf="aviationEvent.contactPersonPhone">Contact Phone: <a class="overview__website" href="{{ contactPhone }}" target="_blank">{{ aviationEvent.contactPersonPhone | phone }}</a></p>
      
      <ng-container *ngIf="isFlightDeckAdmin">
        <p style="padding-top: 20px; font-weight: bold">Flight Deck Admin Only Display Area:</p>
        <p style="padding-top: 5px; padding-left: 10px">Event Creator Member Number: {{ aviationEvent.recid }}</p>
        <p *ngIf="aviationEvent.firstName && aviationEvent.lastName" style="padding-top: 5px; padding-left: 10px">Event Creator Name: {{ aviationEvent.firstName }} {{ aviationEvent.lastName }}</p>
      </ng-container>
    </div>
  </div>
</div>
